import { Boondock, BoondockRating, IBoondockRating, NGRX_BUCKETS, Role, User } from '@curbnturf/entities';
import { boondockComplete } from '@curbnturf/helpers';
import { ratingQuery } from '@curbnturf/rating';
import * as UserSelectors from '@curbnturf/user/src/lib/+state/user.selectors';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BoondockState } from './boondock.reducer';

export const getBoondockFeatureState = createFeatureSelector<BoondockState>(NGRX_BUCKETS.boondock);

export const getBoondockEntities = createSelector(getBoondockFeatureState, (state: BoondockState) => {
  if (state && state.boondocks) {
    const instantiatedBoondocks: { [id: number]: Boondock } = {};
    state.boondocks.forEach((boondock) => {
      if (boondock.id) {
        instantiatedBoondocks[boondock.id] = new Boondock(boondock);
      }
    });

    return instantiatedBoondocks;
  }

  return {};
});

export const getBoondocks = createSelector(getBoondockFeatureState, (state: BoondockState): Boondock[] =>
  state.boondocks.map((el) => new Boondock({ ...el })),
);

export const getError = createSelector(getBoondockFeatureState, (state: BoondockState): string | undefined => state && state.error);

export const getLoaded = createSelector(getBoondockFeatureState, (state: BoondockState): boolean => (state && state.loaded) || false);

export const getCurrentUserBoondocks = createSelector(
  getBoondocks,
  UserSelectors.getCurrentUser,
  (boondocks: Boondock[], user: User): Boondock[] => boondocks.filter((boondock) => boondock.user && boondock.user.id === user.id),
);

export const getBoondocksReadyToEnable = createSelector(
  getBoondocks,
  UserSelectors.getCurrentUser,
  (boondocks: Boondock[], user: User): Boondock[] =>
    boondocks.filter(
      (boondock) =>
        boondock.user &&
        (boondock.user.id === user.id || user.role === Role.admin) &&
        !boondock.available &&
        boondockComplete.completed({ ...boondock, user }),
    ),
);

export const getSelectedBoondockId = createSelector(getBoondockFeatureState, (state) => state && state.selected);

export const getSelectedBoondock = createSelector(getBoondocks, getSelectedBoondockId, (boondocks, selected) =>
  !selected ? null : new Boondock(boondocks.find((el) => el.id === selected || el.syncId === selected)),
);

export const getSelectedRatings = createSelector(
  ratingQuery.getAllBoondockRatings,
  getSelectedBoondockId,
  (ratings: IBoondockRating[], boondockId: number) => {
    return ratings
      .filter((rating) => rating.rated && rating.rated.id === boondockId)
      .map((rating) => new BoondockRating(rating));
  },
);
